import { resource } from '@data-client/rest';
import { BaseEndpoint } from '../endpoints/Base';
export function baseResource({ schema, Endpoint = BaseEndpoint, ...extraOptions }) {
    return resource({
        Endpoint,
        schema,
        // getHeaders(headers: HeadersInit): HeadersInit {
        //   return {
        //     ...headers,
        //     'Content-Type': 'application/json',
        //     Accept: 'application/json'
        //   };
        // },
        ...extraOptions
    });
}
